import { createDatePickerAdder } from './createDatePickerAdder'

export const addComponentForDateField =
  createDatePickerAdder('dateFieldTemplate')
